import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { ContactModel, Permission } from '@/types';
import { MailIcon, PhoneIcon } from '@heroicons/vue/solid';
import { PencilAltIcon } from '@heroicons/vue/outline';
import UiAuditInfo from '@/components/UiAuditInfo.vue';
import { formatDateAsString } from '@/utils/datetime';
import { applyPhoneMask } from '@/utils/number';
import { ContactSentiment, contactSentimentMap } from '@/utils/contactSentiment';
import { ContactHealthScoreBadge } from '.';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactListItem',
  props: {
    modelValue: {
        type: Object as PropType<ContactModel>,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const sentiment = (() => {
    const lastSentiment = props.modelValue.lastSentiment;
    if (!lastSentiment) return null;
    return contactSentimentMap[lastSentiment as ContactSentiment];
})();

const __returned__ = { props, sentiment, get Permission() { return Permission }, get MailIcon() { return MailIcon }, get PhoneIcon() { return PhoneIcon }, get PencilAltIcon() { return PencilAltIcon }, UiAuditInfo, get formatDateAsString() { return formatDateAsString }, get applyPhoneMask() { return applyPhoneMask }, get ContactHealthScoreBadge() { return ContactHealthScoreBadge } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})